import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '@core/services/api.service';
import { EntityApiService } from '@core/services/entity-api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { Observable, firstValueFrom } from 'rxjs';
import { Tag, TagInfo, UserTag } from '../interfaces/tag.interface';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  sellerService = inject(EntityApiService);

  constructor(private _api: ApiService, private router: Router) {}

  getAllTagsWithInfo(): Observable<TagInfo[]> {
    return this._api.request(ApiServiceHolder.tag.getAllTagsWithInfo());
  }

  getTagWithInfo(idTag: number): Observable<TagInfo> {
    return this._api.request(ApiServiceHolder.tag.get(idTag));
  }

  getTagWithInfoByDescription(idTag: string): Observable<TagInfo> {
    return this._api.request(ApiServiceHolder.tag.getByDescription(idTag));
  }

  save(item: Tag): Observable<Tag[]> {
    return this._api.request(ApiServiceHolder.tag.save(item));
  }

  delete(idTag: number): Observable<any> {
    return this._api.request(ApiServiceHolder.tag.delete(idTag));
  }

  getAllUsersByTag(idTag: number): Observable<UserTag[]> {
    return this._api.request(ApiServiceHolder.tag.getAllUsersByTag(idTag));
  }

  isTagPage(): boolean {
    return this.router.url.includes('/tags/');
  }

  isSellerPage(): boolean {
    return this.router.url.includes('/seller/');
  }

  async isSpecialTagPage(): Promise<boolean> {
    if (this.isTagPage()) {
      const tag = await firstValueFrom(
        this.getTagWithInfoByDescription(this.router.url.split('/').pop())
      );

      return tag.special;
    }

    if (this.isSellerPage()) {
      const seller = await firstValueFrom(
        this.sellerService.getBaseDataByPk(+this.router.url.split('/').pop())
      );
      return seller.isAutonomous;
    }
    return false;
  }
}
